import moment from "moment";
import { TFunction } from "i18next";

import { isDarkColor } from "../../../config/DarkColorChecker";
import { formatCurrency } from "../../../config/global";
import { InvoiceDataItem } from "./InvoiceWebTypes";
import { InvoiceWebPagination } from "./InvoiceWebPagination";

type InvoiceWebSummarySectionProps = {
  data: InvoiceDataItem[];
  page: any;
  size: any;
  total: any;
  title: string;
  accentColor?: string;
  t: TFunction;
  onChangePage: (page: any) => void;
  onChangeSize: (size: any) => void;
};

export const InvoiceWebSummarySection = ({
  data,
  page,
  size,
  total,
  title,
  accentColor,
  t,
  onChangePage,
  onChangeSize,
}: InvoiceWebSummarySectionProps) => {
  return (
    <div>
      <div className="container">
        <div className="container rounded-xl px-3 ">
          <div>
            <div>
              <div className="flex flex-col relative justify-center items-center">
                <div className="w-full ">
                  <div className="w-full relative flex">
                    <div className="relative w-full sm:rounded-lg">
                      <div className="flex w-full flex-row justify-start my-2">
                        <h2 className="text-slate-400 text-2xl font-montserrat text-left">
                          {title}
                        </h2>
                      </div>
                      <table className="w-full shadow-xl rounded-lg">
                        <thead
                          className={`text-xs uppercase rounded-xl ${
                            isDarkColor(accentColor)
                              ? "text-white"
                              : "text-black"
                          }`}
                          style={{ background: accentColor }}
                        >
                          <tr>
                            <th
                              scope="col"
                              className="py-3 px-6 text-[0.7vw] font-montserrat"
                            >
                              {t("INVOICE.date")}
                            </th>
                            <th scope="col" className="py-3 px-6">
                              <div className="flex items-center text-[0.7vw] font-montserrat">
                                {t("INVOICE.title")}
                              </div>
                            </th>
                            <th scope="col" className="py-3 px-6">
                              <div className="flex items-center text-[0.7vw] font-montserrat">
                                {t("INVOICE.total")}
                              </div>
                            </th>
                            <th scope="col" className="py-3 px-6">
                              <div className="flex items-center text-[0.7vw] font-montserrat">
                                {t("INVOICE.paid")}
                              </div>
                            </th>
                            <th scope="col" className="py-3 px-6">
                              <div className="flex items-center text-[0.7vw] font-montserrat">
                                {t("INVOICE.totalDue")}
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((item, index) => (
                            <tr
                              key={index}
                              className="bg-white border-b dark:bg-gray-800 cursor-pointer"
                            >
                              <th
                                scope="row"
                                className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap text-[1vw]"
                              >
                                {moment(item.invoiceDate).format("DD MMMM YYYY")}
                              </th>
                              <td className="py-4 px-6 text-left text-[1vw]">
                                {item.title}
                              </td>
                              <td className="py-4 px-6 text-right text-[1vw]">
                                {formatCurrency(item.amount)}
                              </td>
                              <td className="py-4 px-6 text-right text-[1vw]">
                                {formatCurrency(item.paidAmount)}
                              </td>
                              <td className="py-4 px-6 text-right text-[1vw]">
                                {formatCurrency(
                                  (item.amount || 0) - (item.paidAmount || 0),
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <InvoiceWebPagination
              page={page}
              size={size}
              total={total}
              t={t}
              onChangePage={onChangePage}
              onChangeSize={onChangeSize}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
